import React from 'react';

export const AdminPanels = props => {
  return <section className="body-container l2-bg">Panels</section>;
};
